import { createContext, useContext, useState, useEffect } from 'react';

// ── Per-currency payment methods ─────────────────────────────────────────────
// gateway: 'kassify' (défaut) | 'payou' (virement bancaire Payou)
// currency = devise que le PSP attend dans summ pour ce paysys.
// 'EUR' pour ApplePay/GPay/crypto côté Kassify.
// bank.currency = devise LOCALE → summ envoyé tel quel, backend reconvertit via order_id `_<DEVISE>`.
const METHODS_BY_CURRENCY = {
  EUR: {
    mobile: [
      { id: 'applepay', paysys: 'MoneyEUR_AMP_STD', gateway: 'payou', icon: 'apple',  label: 'Pay', currency: 'EUR' },
      { id: 'gpay',     paysys: 'MoneyEUR_AMP_STD', gateway: 'payou', icon: 'google', label: 'Pay', currency: 'EUR' },
    ],
    carte: [
      // { id: 'visa',  paysys: 'VisaEUR',    icon: 'visa_mc', cardnum: 1, currency: 'EUR' },
      // { id: 'visa2', paysys: 'VisaEUR_V2', icon: 'visa_mc', cardnum: 2, currency: 'EUR' },
      // Carte (MoneyEUR_BP, checkout maison) MASQUÉE temporairement — remplacée par
      // l'open banking « Paiement bancaire » ci-dessous (bank). Décommenter pour réactiver :
      // { id: 'money-eur-bp', paysys: 'MoneyEUR_BP', gateway: 'payou', checkout: 'card', icon: 'visa_mc', cardnum: 1, currency: 'EUR' },
    ],
    bank: [
      // Open banking Payou (MoneyEUR_AMP_OPEN) via redirection SCI standard — remplace la carte.
      { id: 'bank-eur', paysys: 'MoneyEUR_AMP_OPEN', gateway: 'payou', icon: 'bank', label: 'Paiement bancaire', currency: 'EUR' },
      // MoneyEUR_AMP_STD (carte/mobile Payou) désactivé — décommenter pour réactiver :
      // { id: 'bank-eur-std', paysys: 'MoneyEUR_AMP_STD', gateway: 'payou', icon: 'bank', label: 'Carte / Mobile (Payou)', currency: 'EUR' },
    ],
  },
  GBP: {
    mobile: [
      { id: 'applepay', paysys: 'Aple_pay',   icon: 'apple',   label: 'Pay',     currency: 'EUR' },
      { id: 'gpay',     paysys: 'google_pay', icon: 'google',  label: 'Pay',     currency: 'EUR' },
      { id: 'revolut',  paysys: 'RevolutGBP', icon: 'revolut', label: 'Revolut', currency: 'GBP' },
    ],
    carte: [
      { id: 'visa',  paysys: 'VisaGBP',    icon: 'visa_mc', cardnum: 1, currency: 'GBP' },
      { id: 'visa2', paysys: 'VisaGBP_v2', icon: 'visa_mc', cardnum: 2, currency: 'GBP' },
    ],
  },
  USD: {
    mobile: [
      { id: 'applepay', paysys: 'Aple_pay',   icon: 'apple',   label: 'Pay',     currency: 'EUR' },
      { id: 'gpay',     paysys: 'google_pay', icon: 'google',  label: 'Pay',     currency: 'EUR' },
      { id: 'revolut',  paysys: 'RevolutUSD', icon: 'revolut', label: 'Revolut', currency: 'USD' },
    ],
    carte: [
      { id: 'visa',  paysys: 'VisaUSD',    icon: 'visa_mc', cardnum: 1, currency: 'USD' },
      { id: 'visa2', paysys: 'VisaUSD_v2', icon: 'visa_mc', cardnum: 2, currency: 'USD' },
    ],
    bank: [
      { id: 'bank-usd', paysys: 'MoneyUSDEcv_Insi_v2', gateway: 'payou', icon: 'deuna', label: 'Deuna', currency: 'USD' },
    ],
  },
  PLN: {
    mobile: [
      { id: 'applepay', paysys: 'Aple_pay',   icon: 'apple',   label: 'Pay',     currency: 'EUR' },
      { id: 'gpay',     paysys: 'google_pay', icon: 'google',  label: 'Pay',     currency: 'EUR' },
      { id: 'revolut',  paysys: 'RevolutPLN', icon: 'revolut', label: 'Revolut', currency: 'PLN' },
      { id: 'blik',     paysys: 'Blik_PLN',   icon: 'blik',    label: 'Blik',    currency: 'PLN' },
    ],
    carte: [
      { id: 'visa', paysys: 'VisaPLN', icon: 'visa_mc', cardnum: 1, currency: 'PLN' },
    ],
  },
  TRY: {
    mobile: [
      { id: 'applepay', paysys: 'Aple_pay',   icon: 'apple',  label: 'Pay', currency: 'EUR' },
      { id: 'gpay',     paysys: 'google_pay', icon: 'google', label: 'Pay', currency: 'EUR' },
    ],
    carte: [
      { id: 'visa',  paysys: 'VisaTRY',    icon: 'visa_mc', cardnum: 1, currency: 'TRY' },
      { id: 'visa2', paysys: 'VisaTRY_v2', icon: 'visa_mc', cardnum: 2, currency: 'TRY' },
    ],
  },
  RON: {
    mobile: [
      { id: 'applepay', paysys: 'Aple_pay',   icon: 'apple',   label: 'Pay',     currency: 'EUR' },
      { id: 'gpay',     paysys: 'google_pay', icon: 'google',  label: 'Pay',     currency: 'EUR' },
      { id: 'revolut',  paysys: 'RevolutEUR', icon: 'revolut', label: 'Revolut', currency: 'EUR' },
    ],
    carte: [
      { id: 'visa', paysys: 'VisaRON', icon: 'visa_mc', cardnum: 1, currency: 'RON' },
    ],
  },
  CHF: {
    mobile: [
      { id: 'applepay', paysys: 'Aple_pay',   icon: 'apple',   label: 'Pay',     currency: 'EUR' },
      { id: 'gpay',     paysys: 'google_pay', icon: 'google',  label: 'Pay',     currency: 'EUR' },
      { id: 'revolut',  paysys: 'RevolutEUR', icon: 'revolut', label: 'Revolut', currency: 'EUR' },
    ],
    carte: [
      { id: 'visa',  paysys: 'VisaEUR',    icon: 'visa_mc', cardnum: 1, currency: 'EUR' },
      { id: 'visa2', paysys: 'VisaEUR_V2', icon: 'visa_mc', cardnum: 2, currency: 'EUR' },
    ],
  },
  CAD: {
    mobile: [
      { id: 'applepay', paysys: 'Aple_pay',   icon: 'apple',  label: 'Pay', currency: 'EUR' },
      { id: 'gpay',     paysys: 'google_pay', icon: 'google', label: 'Pay', currency: 'EUR' },
    ],
    carte: [
      { id: 'visa', paysys: 'VisaCAD', icon: 'visa_mc', cardnum: 1, currency: 'CAD' },
    ],
  },
  AUD: {
    mobile: [
      { id: 'applepay', paysys: 'Aple_pay',   icon: 'apple',  label: 'Pay', currency: 'EUR' },
      { id: 'gpay',     paysys: 'google_pay', icon: 'google', label: 'Pay', currency: 'EUR' },
    ],
    carte: [
      { id: 'visa', paysys: 'VisaAUD', icon: 'visa_mc', cardnum: 1, currency: 'AUD' },
    ],
  },
  MAD: {
    mobile: [
      { id: 'applepay', paysys: 'Aple_pay',   icon: 'apple',  label: 'Pay', currency: 'EUR' },
      { id: 'gpay',     paysys: 'google_pay', icon: 'google', label: 'Pay', currency: 'EUR' },
    ],
    carte: [
      { id: 'visa',  paysys: 'VisaMAD',    icon: 'visa_mc', cardnum: 1, currency: 'MAD' },
      { id: 'visa2', paysys: 'VisaMAD_v2', icon: 'visa_mc', cardnum: 2, currency: 'MAD' },
    ],
  },
  // ── FRANC CFA (XOF Afrique de l'Ouest / XAF Afrique Centrale) ────────────────
  // mobile/carte = Kassify EUR. Virement local Payou à ajouter dès réception du paysys.
  XOF: {
    mobile: [
      { id: 'applepay', paysys: 'Aple_pay',   icon: 'apple',  label: 'Pay', currency: 'EUR' },
      { id: 'gpay',     paysys: 'google_pay', icon: 'google', label: 'Pay', currency: 'EUR' },
    ],
    carte: [
      { id: 'visa',  paysys: 'VisaEUR',    icon: 'visa_mc', cardnum: 1, currency: 'EUR' },
      { id: 'visa2', paysys: 'VisaEUR_V2', icon: 'visa_mc', cardnum: 2, currency: 'EUR' },
    ],
    bank: [
      { id: 'bank-xof', paysys: 'MoneyXOF_SaB', gateway: 'payou', icon: 'pagomovil', label: 'Mobile Money', currency: 'XOF' },
    ],
  },
  XAF: {
    mobile: [
      { id: 'applepay', paysys: 'Aple_pay',   icon: 'apple',  label: 'Pay', currency: 'EUR' },
      { id: 'gpay',     paysys: 'google_pay', icon: 'google', label: 'Pay', currency: 'EUR' },
    ],
    carte: [
      { id: 'visa',  paysys: 'VisaEUR',    icon: 'visa_mc', cardnum: 1, currency: 'EUR' },
      { id: 'visa2', paysys: 'VisaEUR_V2', icon: 'visa_mc', cardnum: 2, currency: 'EUR' },
    ],
    // bank: [ { id: 'bank-xaf', paysys: 'PAYSYS_XAF_A_VENIR', gateway: 'payou', icon: 'bank', label: 'Transfert bancaire / Mobile Money', currency: 'XAF' } ],
  },
  // ── AFRIQUE (Mobile Money Payou, payout opérateur en USDT) ───────────────────
  // Mobile money local + crypto (ajouté globalement). Kassify carte/mobile non ajouté ici.
  BIF: {
    bank: [
      { id: 'bank-bif', paysys: 'MoneyBIF_SaB', gateway: 'payou', icon: 'pagomovil', label: 'Mobile Money (Lumicash, Vodacom)', currency: 'BIF' },
    ],
  },
  CDF: {
    bank: [
      { id: 'bank-cdf', paysys: 'MoneyCDF_SaB', gateway: 'payou', icon: 'pagomovil', label: 'Mobile Money (Orange, Airtel, Afrimoney)', currency: 'CDF' },
    ],
  },
  GHS: {
    bank: [
      { id: 'bank-ghs', paysys: 'MoneyGHS_SaB', gateway: 'payou', icon: 'pagomovil', label: 'Mobile Money (MTN, Vodafone, AirtelTigo)', currency: 'GHS' },
    ],
  },
  NGN: {
    bank: [
      { id: 'bank-ngn', paysys: 'MoneyNGN_SaB', gateway: 'payou', icon: 'bank', label: 'Bank Transfer / OPay / PalmPay', currency: 'NGN' },
    ],
  },
  ZMW: {
    bank: [
      { id: 'bank-zmw', paysys: 'MoneyZMW_SaB', gateway: 'payou', icon: 'pagomovil', label: 'Mobile Money (Airtel, MTN)', currency: 'ZMW' },
    ],
  },
  UGX: {
    bank: [
      { id: 'bank-ugx', paysys: 'MoneyUGX_SaB', gateway: 'payou', icon: 'pagomovil', label: 'Mobile Money (Airtel, MTN)', currency: 'UGX' },
    ],
  },
  // ── Paysys NON confirmés — pattern probable Money{CUR}_SaB, à valider avant activation.
  // En attendant : crypto uniquement (ajouté globalement).
  GMD: {
    bank: [
      // { id: 'bank-gmd', paysys: 'MoneyGMD_SaB', gateway: 'payou', icon: 'pagomovil', label: 'Mobile Money (Afrimoney, Wave)', currency: 'GMD' },
    ],
  },
  KES: {
    bank: [
      // { id: 'bank-kes', paysys: 'MoneyKES_SaB', gateway: 'payou', icon: 'pagomovil', label: 'Mobile Money (M-Pesa, Airtel)', currency: 'KES' },
    ],
  },
  RWF: {
    bank: [
      // { id: 'bank-rwf', paysys: 'MoneyRWF_SaB', gateway: 'payou', icon: 'pagomovil', label: 'Mobile Money (MTN)', currency: 'RWF' },
    ],
  },
  // ── LATAM : Kassify retiré (carte + mobile Apple/GPay/Revolut). Restent : virement Payou local + crypto (ajouté globalement). ──
  MXN: {
    bank: [
      { id: 'bank-mxn', paysys: 'may_MoneyMXN', gateway: 'payou', icon: 'bank', label: 'Transferencia bancaria', currency: 'MXN' },
    ],
  },
  ARS: {
    bank: [
      { id: 'bank-ars', paysys: 'MoneyARS_Insi', gateway: 'payou', icon: 'mercadopago', label: 'MercadoPago / Transferencia', currency: 'ARS' },
    ],
  },
  BRL: {
    bank: [
      { id: 'bank-brl', paysys: 'MoneyBRL_Sp', gateway: 'payou', icon: 'pix', label: 'Pix', currency: 'BRL' },
    ],
  },
  VES: {
    bank: [
      { id: 'bank-ves', paysys: 'MoneyVES_Insi', gateway: 'payou', icon: 'pagomovil', label: 'Pago Móvil', currency: 'VES' },
    ],
  },
  PEN: {
    bank: [
      { id: 'bank-pen', paysys: 'MoneyPEN_Sp', gateway: 'payou', icon: 'bank', label: 'Transferencia bancaria', currency: 'PEN' },
    ],
  },
  COP: {
    bank: [
      { id: 'bank-cop', paysys: 'MoneyCOP_Sp', gateway: 'payou', icon: 'bank', label: 'Transferencia bancaria', currency: 'COP' },
    ],
  },

  DEFAULT: {
    mobile: [
      { id: 'applepay', paysys: 'Aple_pay',   icon: 'apple',   label: 'Pay',     currency: 'EUR' },
      { id: 'gpay',     paysys: 'google_pay', icon: 'google',  label: 'Pay',     currency: 'EUR' },
      { id: 'revolut',  paysys: 'RevolutEUR', icon: 'revolut', label: 'Revolut', currency: 'EUR' },
    ],
    carte: [
      { id: 'visa',  paysys: 'VisaEUR',    icon: 'visa_mc', cardnum: 1, currency: 'EUR' },
      { id: 'visa2', paysys: 'VisaEUR_V2', icon: 'visa_mc', cardnum: 2, currency: 'EUR' },
    ],
    bank: [
      // MoneyEUR_AMP_OPEN (virement instantané) DÉSACTIVÉ — défaillant. Décommenter pour réactiver :
      // { id: 'bank-eur', paysys: 'MoneyEUR_AMP_OPEN', gateway: 'payou', icon: 'bank', label: 'Virement bancaire instantané', currency: 'EUR' },
    ],
  },
};

// Crypto — universel, Kassify attend toujours de l'EUR en summ
const CRYPTO_METHODS = [
  { id: 'btc',  paysys: 'Bitcoin',     icon: 'btc',  label: 'Bitcoin',  currency: 'EUR' },
  { id: 'eth',  paysys: 'Ethereum',    icon: 'eth',  label: 'Ethereum', currency: 'EUR' },
  { id: 'usdt', paysys: 'TetherERC20', icon: 'usdt', label: 'USDT',     currency: 'EUR' },
  { id: 'ltc',  paysys: 'Litecoin',    icon: 'ltc',  label: 'Litecoin', currency: 'EUR' },
];

// Carte bancaire internationale (Payou MoneyUSD_BP). Proposée en Afrique & LATAM en
// complément du moyen local. Le montant envoyé est en EUR (jamais la devise locale) —
// currency: 'EUR' → payAmount fait localAmount / rate. Devient l'onglet principal si
// aucun moyen local n'est dispo. (Écart de conversion USD/EUR assumé, négligeable.)
const USD_CARD_METHODS = [
  { id: 'card-usd', paysys: 'MoneyUSD_BP', gateway: 'payou', icon: 'visa_mc', label: 'Carte', currency: 'EUR' },
];

// ── Champs de retrait (onglet "banque") par devise ────────────────────────────
// IBAN/BIC par défaut, moyen d'encaissement LATAM local sinon. Front-only : le
// payout de ces moyens n'est pas branché au backend (stocké tel quel dans notes).
// `labelKey`/`phKey` = clé i18n ; `label`/`placeholder` = texte littéral (LATAM).
const WD_HOLDER = { name: 'titulaire', labelKey: 'withdrawal.accountHolder', phKey: 'withdrawal.holderPlaceholder' };

// Afrique — Mobile Money : titulaire + numéro (+ opérateur si plusieurs). Comme la
// LATAM, ces champs sont FRONT-ONLY (payout réel en USDT côté opérateur).
const WD_MOMO_OPERATOR = { name: 'operator', label: 'Opérateur', placeholder: 'Orange, MTN, Moov, Wave…' };
const momo = (tabLabel, phPlaceholder, withOperator = true) => ({
  method: 'mobilemoney',
  tabLabel,
  fields: [
    WD_HOLDER,
    { name: 'phone', label: 'Numéro Mobile Money', placeholder: phPlaceholder },
    ...(withOperator ? [WD_MOMO_OPERATOR] : []),
  ],
});

const WITHDRAW_DEFAULT = {
  method: 'iban',
  tabLabelKey: 'withdrawal.tabBank',
  fields: [
    WD_HOLDER,
    { name: 'iban', label: 'IBAN',         phKey: 'withdrawal.ibanPlaceholder', mono: true },
    { name: 'bic',  label: 'BIC / SWIFT',  phKey: 'withdrawal.bicPlaceholder',  mono: true },
  ],
};

const WITHDRAW_BY_CURRENCY = {
  BRL: { method: 'pix', tabLabel: 'Pix', fields: [
    WD_HOLDER,
    { name: 'pix_key', label: 'Chave Pix', placeholder: 'CPF, e-mail, telefone ou chave aleatória', mono: true },
  ] },
  MXN: { method: 'clabe', tabLabel: 'Transferencia', fields: [
    WD_HOLDER,
    { name: 'clabe', label: 'CLABE', placeholder: '18 dígitos', mono: true },
  ] },
  ARS: { method: 'cbu', tabLabel: 'Transferencia', fields: [
    WD_HOLDER,
    { name: 'cbu', label: 'CBU / CVU / Alias', placeholder: '22 dígitos o alias', mono: true },
  ] },
  // Venezuela — Pago Móvil : uniquement téléphone + cédula (demande minimale).
  VES: { method: 'pagomovil', tabLabel: 'Pago Móvil', fields: [
    { name: 'phone',  label: 'Teléfono', placeholder: '0412 000 0000' },
    { name: 'cedula', label: 'Cédula',   placeholder: 'V-00000000' },
  ] },
  PEN: { method: 'cci', tabLabel: 'Transferencia', fields: [
    WD_HOLDER,
    { name: 'cci', label: 'CCI', placeholder: '20 dígitos', mono: true },
  ] },
  COP: { method: 'bank_co', tabLabel: 'Transferencia', fields: [
    WD_HOLDER,
    { name: 'account', label: 'Número de cuenta', placeholder: 'Cuenta de ahorros / corriente', mono: true },
  ] },
  // ── Afrique — Mobile Money (Franc CFA multi-pays + francs locaux) ──
  XOF: momo('Mobile Money', '07 00 00 00 00'),   // Orange / MTN / Moov / Wave
  XAF: momo('Mobile Money', '6 00 00 00 00'),     // Orange / MTN Cameroun…
  BIF: momo('Mobile Money', '79 00 00 00'),       // Lumicash / EcoCash Burundi
  CDF: momo('Mobile Money', '80 000 0000'),       // M-Pesa / Orange / Airtel RDC
  GHS: momo('Mobile Money', '024 000 0000'),      // MTN / Telecel / AirtelTigo Ghana
  ZMW: momo('Mobile Money', '097 000 0000'),      // MTN / Airtel / Zamtel Zambie
  UGX: momo('Mobile Money', '070 000 0000'),      // MTN / Airtel Ouganda
  GMD: momo('Mobile Money', '300 0000'),          // Gambie
  RWF: momo('Mobile Money', '078 000 0000'),      // MTN / Airtel Rwanda
  // Kenya — M-Pesa (opérateur unique) : titulaire + numéro suffisent.
  KES: { method: 'mpesa', tabLabel: 'M-Pesa', fields: [
    WD_HOLDER,
    { name: 'phone', label: 'Numéro M-Pesa', placeholder: '07XX XXX XXX' },
  ] },
  // Nigeria — virement bancaire (NUBAN 10 chiffres), plutôt que Mobile Money.
  NGN: { method: 'bank_ng', tabLabel: 'Bank Transfer', fields: [
    WD_HOLDER,
    { name: 'account', label: 'Account number', placeholder: '10 chiffres (NUBAN)', mono: true },
    { name: 'bank',    label: 'Bank',           placeholder: 'GTBank, Access, Zenith…' },
  ] },
};

// ── Presets LATAM ─────────────────────────────────────────────────────────────
// betChips / presets / wdPresets en devise locale (équiv. ~10-200€ / 50-500€ / 300-800€ EUR)
// ⚠️ ARS et VES très volatils — à ajuster régulièrement.

// ── Zone LATAM (virement Payou local, Kassify retiré) ────────────────────────
const LATAM_CURRENCIES = ['MXN', 'ARS', 'BRL', 'VES', 'PEN', 'COP'];

// ── Zone Afrique (Franc CFA + Mobile Money Payou) ────────────────────────────
const AFRICA_CURRENCIES = ['XOF', 'XAF', 'BIF', 'CDF', 'GHS', 'NGN', 'ZMW', 'UGX', 'GMD', 'KES', 'RWF'];

// ── Base prices in EUR — single source of truth, PAR ZONE ────────────────────
// Toutes les valeurs sont en EUR puis converties en devise locale via conv().
const BASE_EUR_DEFAULT = {
  kyc:           80,
  jdd:           70,
  validAmt:      99,
  freeBet:         100,
  depositBonusCap: 500,
  bonus:           200,
  tierBronze:    40,
  tierSilver:    80,
  tierGold:      120,
  minWithdrawal: 500,
};
// LATAM : frais réduits + retrait mini 100 € (frais Step4 = 9 % ⇒ plancher ≈ 9 €).
const BASE_EUR_LATAM = {
  ...BASE_EUR_DEFAULT,
  kyc:           20,
  jdd:           30,
  validAmt:      40,
  tierBronze:    15,
  tierSilver:    25,
  tierGold:      40,
  minWithdrawal: 100,
};
// AFRIQUE : mêmes prix que LATAM (frais réduits JDD/steps + retrait mini 100 €),
// sauf KYC abaissé à 15 € (spécifique Afrique).
const BASE_EUR_AFRICA = { ...BASE_EUR_LATAM, kyc: 15 };
function baseEurFor(cur) {
  if (LATAM_CURRENCIES.includes(cur))  return BASE_EUR_LATAM;
  if (AFRICA_CURRENCIES.includes(cur)) return BASE_EUR_AFRICA;
  return BASE_EUR_DEFAULT;
}

// ── Presets par devise — montants ronds affichés dans l'UI ───────────────────
// betChips = mises rapides BetSlip | presets = dépôt | wdPresets = retrait
const CURRENCY_PRESETS = {
  EUR: { betChips: [10, 25, 50, 100, 200],              presets: [20, 50, 100, 200],              wdPresets: [900, 1200, 1500]              },
  GBP: { betChips: [10, 20, 50, 100, 200],              presets: [50, 100, 200, 500],             wdPresets: [700, 1000, 1200]              },
  USD: { betChips: [10, 25, 50, 100, 200],              presets: [50, 100, 200, 500],             wdPresets: [900, 1200, 1500]              },
  CHF: { betChips: [10, 25, 50, 100, 200],              presets: [50, 100, 200, 500],             wdPresets: [800, 1000, 1200]              },
  CAD: { betChips: [15, 35, 75, 150, 300],              presets: [75, 150, 300, 750],             wdPresets: [1200, 1500, 2000]             },
  AUD: { betChips: [15, 40, 80, 160, 300],              presets: [80, 200, 400, 800],             wdPresets: [1400, 1800, 2500]             },
  PLN: { betChips: [50, 100, 250, 500, 1000],           presets: [250, 500, 1000, 2000],          wdPresets: [3500, 4500, 6000]             },
  RON: { betChips: [50, 125, 250, 500, 1000],           presets: [250, 500, 1000, 2500],          wdPresets: [4000, 5000, 6000]             },
  TRY: { betChips: [350, 750, 1500, 3500, 7000],        presets: [1500, 3500, 7000, 17500],       wdPresets: [30000, 40000, 50000]          },
  MAD: { betChips: [100, 250, 500, 1000, 2000],         presets: [500, 1000, 2000, 5000],         wdPresets: [9000, 11000, 14000]           },
  // LATAM — dépôt : 1er chip ≈ 10 € | retrait : chips VOLONTAIREMENT bas (~10-250 €) pour ne PAS révéler le mini (imposé seulement à la Step 4).
  MXN: { betChips: [200, 500, 1000, 2000, 4000],        presets: [200, 500, 1000, 2500],          wdPresets: [200, 1000, 5000]           },
  ARS: { betChips: [20000, 50000, 100000, 200000, 400000], presets: [25000, 50000, 100000, 250000], wdPresets: [20000, 100000, 500000]   },
  BRL: { betChips: [60, 150, 300, 600, 1200],           presets: [60, 150, 300, 600],             wdPresets: [60, 300, 1500]             },
  VES: { betChips: [6000, 15000, 30000, 60000, 120000], presets: [9500, 15000, 30000, 60000],     wdPresets: [6000, 30000, 150000]       },
  PEN: { betChips: [40, 100, 200, 400, 800],            presets: [40, 100, 250, 500],             wdPresets: [40, 200, 1000]              },
  COP: { betChips: [50000, 120000, 250000, 500000, 1000000], presets: [40000, 100000, 250000, 500000], wdPresets: [40000, 200000, 1000000] },
  // Franc CFA (1 EUR = 655,957 fixe) — XOF et XAF partagent les mêmes montants
  XOF: { betChips: [6000, 15000, 30000, 65000, 130000],       presets: [7000, 15000, 35000, 70000],     wdPresets: [600000, 800000, 1000000]      },
  XAF: { betChips: [6000, 15000, 30000, 65000, 130000],       presets: [7000, 15000, 35000, 70000],     wdPresets: [600000, 800000, 1000000]      },
  // ── Afrique (Mobile Money) — montants ronds ; wdPresets bas (LATAM-style) pour ne pas révéler le mini.
  BIF: { betChips: [35000, 85000, 170000, 340000, 680000],    presets: [35000, 85000, 170000, 340000],    wdPresets: [35000, 170000, 850000]     },
  CDF: { betChips: [35000, 85000, 170000, 335000, 670000],    presets: [30000, 65000, 135000, 270000],    wdPresets: [35000, 170000, 850000]     },
  GHS: { betChips: [150, 350, 700, 1500, 3000],               presets: [150, 350, 700, 1400],             wdPresets: [150, 700, 3000]            },
  NGN: { betChips: [17500, 45000, 90000, 175000, 350000],     presets: [16000, 40000, 80000, 160000],     wdPresets: [17500, 90000, 450000]      },
  ZMW: { betChips: [300, 700, 1400, 2800, 5600],              presets: [250, 550, 1100, 2200],            wdPresets: [300, 1400, 7000]           },
  UGX: { betChips: [45000, 110000, 215000, 430000, 860000],   presets: [45000, 110000, 220000, 430000],   wdPresets: [45000, 215000, 1100000]    },
  GMD: { betChips: [800, 2000, 4000, 8000, 16000],            presets: [900, 2000, 4500, 9000],           wdPresets: [800, 4000, 20000]          },
  KES: { betChips: [1500, 3500, 7500, 15000, 30000],          presets: [1500, 4000, 7500, 15000],         wdPresets: [1500, 7500, 35000]         },
  RWF: { betChips: [17000, 42000, 85000, 170000, 335000],     presets: [18000, 45000, 90000, 180000],     wdPresets: [17000, 85000, 420000]      },
};

// ── 1 EUR = X — add a line here to support a new currency ────────────────────
// ⚠️ ARS et VES très volatils — à ajuster régulièrement.
const EXCHANGE_RATES = {
  EUR: 1,
  GBP: 0.86,
  USD: 1.16,
  TRY: 53.17,
  RON: 5.24,
  PLN: 4.29,
  CHF: 0.92,
  CAD: 1.62,
  AUD: 1.62,
  MAD: 10.69,
  // LATAM (Payou bank)
  MXN: 19.70,
  ARS: 1753.34,
  BRL: 5.98,
  VES: 918.24,
  PEN: 3.85,
  COP: 3737.90,
  // Franc CFA — parité fixe avec l'EUR (1 EUR = 655,957)
  XOF: 655.957,
  XAF: 655.957,
  // Afrique (Mobile Money) — ⚠️ taux approximatifs, à ajuster régulièrement.
  BIF: 3400,
  CDF: 2674.60,
  GHS: 13.21,
  NGN: 1536,
  ZMW: 22.23,
  UGX: 4300,
  GMD: 85,
  KES: 150,
  RWF: 1710,
};

// ── Currency symbols ──────────────────────────────────────────────────────────
const CURRENCY_SYMBOLS = {
  EUR: '€',
  GBP: '£',
  USD: '$',
  TRY: '₺',
  RON: 'lei',
  PLN: 'zł',
  CHF: 'CHF',
  CAD: 'CA$',
  AUD: 'AU$',
  MAD: 'MAD',
  // LATAM
  MXN: 'MX$',
  ARS: 'AR$',
  BRL: 'R$',
  VES: 'Bs.S',
  PEN: 'S/',
  COP: 'COL$',
  // Franc CFA
  XOF: 'FCFA',
  XAF: 'FCFA',
  // Afrique (Mobile Money)
  BIF: 'FBu',
  CDF: 'FC',
  GHS: 'GH₵',
  NGN: '₦',
  ZMW: 'ZK',
  UGX: 'USh',
  GMD: 'D',
  KES: 'KSh',
  RWF: 'FRw',
};

// ── Repli country_code → devise ──────────────────────────────────────────────
// Utilisé quand ipapi.co ne renvoie PAS de devise (champ vide / provider de secours)
// ou renvoie une devise qu'on ne gère pas. Ne couvre que les devises présentes
// dans EXCHANGE_RATES ; tout le reste retombe sur EUR.
const COUNTRY_TO_CURRENCY = {
  // Zone euro
  AT: 'EUR', BE: 'EUR', HR: 'EUR', CY: 'EUR', EE: 'EUR', FI: 'EUR', FR: 'EUR',
  DE: 'EUR', GR: 'EUR', IE: 'EUR', IT: 'EUR', LV: 'EUR', LT: 'EUR', LU: 'EUR',
  MT: 'EUR', NL: 'EUR', PT: 'EUR', SK: 'EUR', SI: 'EUR', ES: 'EUR',
  GB: 'GBP',
  US: 'USD', EC: 'USD', // Équateur dollarisé (paysys Deuna)
  TR: 'TRY', RO: 'RON', PL: 'PLN', CH: 'CHF', LI: 'CHF',
  CA: 'CAD', AU: 'AUD', MA: 'MAD',
  // LATAM
  MX: 'MXN', AR: 'ARS', BR: 'BRL', VE: 'VES', PE: 'PEN', CO: 'COP',
  // Franc CFA Ouest (UEMOA)
  BJ: 'XOF', BF: 'XOF', CI: 'XOF', GW: 'XOF', ML: 'XOF', NE: 'XOF', SN: 'XOF', TG: 'XOF',
  // Franc CFA Centre (CEMAC)
  CM: 'XAF', CF: 'XAF', TD: 'XAF', CG: 'XAF', GQ: 'XAF', GA: 'XAF',
  // Afrique (Mobile Money) — BJ (Benin) déjà mappé sur XOF ci-dessus
  BI: 'BIF', CD: 'CDF', GH: 'GHS', NG: 'NGN', ZM: 'ZMW', UG: 'UGX',
  GM: 'GMD', KE: 'KES', RW: 'RWF',
};

// ── Override paysys PAR PAYS (même devise, PSP différent selon le pays) ───────
// XOF est partagé par plusieurs pays mais Payou attend une clé par pays :
//   Benin (BJ, défaut) = MoneyXOF_SaB · Sénégal (SN) = MoneyXOF_Sp.
// Appliqué dans buildGeo sur la map `paysys` (utilisée par Deposit/WithdrawalFunnel).
const COUNTRY_PAYSYS = {
  SN: { 'bank-xof': 'MoneyXOF_Sp' },
};

// Pays XOF avec une clé Payou Mobile Money CONFIRMÉE. Les autres pays UEMOA
// (Burkina, Côte d'Ivoire, Mali, Niger, Togo, Guinée-Bissau) partagent la devise
// XOF mais n'ont PAS encore de clé validée → on retire leur Mobile Money (carte
// USD MoneyUSD_BP + crypto restent). Ajouter un pays ici dès réception de sa clé
// (+ une entrée COUNTRY_PAYSYS si la clé diffère de MoneyXOF_SaB).
const XOF_BANK_COUNTRIES = ['BJ', 'SN'];

// Choix de la devise : 1) devise API si supportée → 2) repli par pays → 3) EUR.
function pickCurrency(countryCode, apiCurrency) {
  const cur = (apiCurrency || '').toUpperCase();
  if (cur && EXCHANGE_RATES[cur]) return cur;
  const cc = (countryCode || '').toUpperCase();
  if (cc && COUNTRY_TO_CURRENCY[cc]) return COUNTRY_TO_CURRENCY[cc];
  return 'EUR';
}

// Rounds to 2 significant figures for clean-looking amounts
function niceRound(n) {
  if (n <= 0) return 0;
  const mag = Math.pow(10, Math.floor(Math.log10(n)) - 1);
  return Math.round(n / mag) * mag;
}

function buildPrices(cur) {
  const rate   = EXCHANGE_RATES[cur] || 1;
  const symbol = CURRENCY_SYMBOLS[cur] || '€';
  const conv   = (n) => niceRound(n * rate);
  const cp     = CURRENCY_PRESETS[cur] || CURRENCY_PRESETS.EUR;
  const base   = baseEurFor(cur);
  return {
    symbol,
    rate,
    kyc:             conv(base.kyc),
    jdd:             conv(base.jdd),
    validAmt:        conv(base.validAmt),
    freeBet:         conv(base.freeBet),
    depositBonusCap: conv(base.depositBonusCap),
    bonus:           conv(base.bonus),
    presets:         cp.presets,
    wdPresets:       cp.wdPresets,
    betChips:        cp.betChips,
    tierBronze:      conv(base.tierBronze),
    tierSilver:      conv(base.tierSilver),
    tierGold:        conv(base.tierGold),
    minWithdrawal:   conv(base.minWithdrawal),
  };
}

export const CURRENCIES = Object.keys(EXCHANGE_RATES).map((code) => ({
  code,
  symbol: CURRENCY_SYMBOLS[code] || code,
}));

const CURRENCY_STORAGE_KEY = 'app_currency';
const COUNTRY_STORAGE_KEY = 'app_country';

const GeoContext = createContext(null);

const CACHE_KEY = 'app_geo';
const CACHE_TTL = 24 * 60 * 60 * 1000; // 24 h

function readCache() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (Date.now() - parsed.ts > CACHE_TTL) return null;
    return parsed;
  } catch { return null; }
}

function buildGeo(country, currency) {
  const cur       = currency || 'EUR';
  const rate      = EXCHANGE_RATES[cur] || 1;
  const cms       = METHODS_BY_CURRENCY[cur] || METHODS_BY_CURRENCY.DEFAULT;
  const methods   = { ...cms, crypto: CRYPTO_METHODS };
  const paysys    = {};
  const methodMap = {};
  Object.values(methods).flat().forEach((m) => {
    paysys[m.id]    = m.paysys;
    methodMap[m.id] = m;
  });

  // Override paysys par pays (ex. XOF : Benin=SaB défaut, Sénégal=Sp).
  const cpOverride = COUNTRY_PAYSYS[country];
  if (cpOverride) {
    Object.entries(cpOverride).forEach(([id, ps]) => {
      if (paysys[id] !== undefined) paysys[id] = ps;
    });
  }
  const zone = LATAM_CURRENCIES.includes(cur) ? 'latam'
             : AFRICA_CURRENCIES.includes(cur) ? 'africa'
             : 'default';

  // XOF : retirer le Mobile Money pour les pays sans clé Payou confirmée (seuls
  // Bénin + Sénégal en ont une). La carte USD + la crypto restent → la carte
  // devient le moyen principal pour ces pays. Voir XOF_BANK_COUNTRIES.
  if (cur === 'XOF' && !XOF_BANK_COUNTRIES.includes(country)) {
    methods.bank = [];
  }

  // Afrique & LATAM : la carte USD (Payou MoneyUSD_BP) est proposée pour TOUS les
  // pays, EN PLUS du moyen local (virement/Mobile Money). Le moyen local reste
  // principal ; la carte devient principale s'il n'y a pas de virement (pas de clé).
  if (zone === 'latam' || zone === 'africa') {
    const hasUsdCard = (methods.carte || []).some((m) => m.id === 'card-usd');
    if (!hasUsdCard) {
      methods.carte = [...(methods.carte || []), ...USD_CARD_METHODS];
      USD_CARD_METHODS.forEach((m) => { paysys[m.id] = m.paysys; methodMap[m.id] = m; });
    }
  }

  const tabs   = Object.keys(methods).filter((k) => methods[k].length > 0);
  const prices = buildPrices(cur);

  function payAmount(methodId, localAmount) {
    const m = methodMap[methodId];
    return m?.currency === cur ? localAmount : localAmount / rate;
  }

  function methodCurrency(methodId) {
    return methodMap[methodId]?.currency || 'EUR';
  }

  function methodGateway(methodId) {
    return methodMap[methodId]?.gateway || 'kassify';
  }

  // 'card' = checkout carte maison (formulaire inline + appel API Payou côté
  // serveur, cf payou-card.php) au lieu de la redirection SCI. null sinon.
  function methodCheckout(methodId) {
    return methodMap[methodId]?.checkout || null;
  }

  const withdraw = WITHDRAW_BY_CURRENCY[cur] || WITHDRAW_DEFAULT;

  return { country, currency: cur, paysys, methods, tabs, prices, payAmount, methodCurrency, methodGateway, methodCheckout, withdraw, zone };
}

function getInitialGeo() {
  const savedCurrency = localStorage.getItem(CURRENCY_STORAGE_KEY);
  const savedCountry = localStorage.getItem(COUNTRY_STORAGE_KEY);
  if (savedCurrency && EXCHANGE_RATES[savedCurrency]) {
    return buildGeo(savedCountry || '??', savedCurrency);
  }
  const cached = readCache();
  if (cached) return buildGeo(cached.country, cached.currency);
  return buildGeo('FR', 'EUR');
}

export function GeoProvider({ children }) {
  const [geo, setGeo] = useState(getInitialGeo);

  const setCurrency = (code) => {
    if (!EXCHANGE_RATES[code]) return;
    localStorage.setItem(CURRENCY_STORAGE_KEY, code);
    setGeo((prev) => buildGeo(prev.country, code));
  };

  const setCountry = (code) => {
    localStorage.setItem(COUNTRY_STORAGE_KEY, code);
    setGeo((prev) => buildGeo(code, prev.currency));
  };

  useEffect(() => {
    if (localStorage.getItem(CURRENCY_STORAGE_KEY)) return; // user chose manually
    if (readCache()) return;

    let cancelled = false;

    const apply = (country, currency, ip) => {
      if (cancelled) return;
      console.log(`[Geo] IP: ${ip} | Country: ${country} | Currency: ${currency}`);
      localStorage.setItem(CACHE_KEY, JSON.stringify({ country, currency, ts: Date.now() }));
      localStorage.setItem(COUNTRY_STORAGE_KEY, country);
      setGeo(buildGeo(country, currency));
    };

    const primaryUrl = process.env.REACT_APP_IP_API_URL || 'https://ipapi.co/json/';

    // Secours si ipapi échoue / quota 429 / 403 : ipwho.is (gratuit, sans clé).
    // Renvoie la devise dans `currency.code`.
    const fromBackup = () =>
      fetch('https://ipwho.is/')
        .then((r) => r.json())
        .then((d) => {
          if (!d || d.success === false) throw new Error('backup geo failed');
          const country = d.country_code || 'FR';
          apply(country, pickCurrency(country, d.currency && d.currency.code), d.ip);
        });

    fetch(primaryUrl)
      .then((r) => { if (!r.ok) throw new Error('ipapi ' + r.status); return r.json(); })
      .then((data) => {
        // ipapi rate-limité renvoie un HTTP 200 avec { error:true, reason:'RateLimited' }
        // (PAS un 4xx) → body sans pays → sinon on retomberait en EUR/FR par défaut.
        // On force le repli sur le provider de secours dans ce cas.
        if (!data || data.error || (!data.country_code && !data.country)) {
          throw new Error('ipapi unusable body');
        }
        const country = data.country_code || data.country;
        apply(country, pickCurrency(country, data.currency), data.ip);
      })
      .catch(() => fromBackup())   // ipapi KO / rate-limit → provider de secours
      .catch(() => {});            // les deux KO → on garde EUR/FR par défaut

    return () => { cancelled = true; };
  }, []);

  return <GeoContext.Provider value={{ ...geo, setCurrency, setCountry }}>{children}</GeoContext.Provider>;
}

export function useGeo() {
  return useContext(GeoContext);
}
